
import {Component, computed, inject, signal} from '@angular/core';
import {FormBuilder, FormControl, ReactiveFormsModule, Validators,} from '@angular/forms';
import {noSoloEspacios} from '../../../clientes/pages/clientes-form-component/validations';
import {CommonModule, NgClass} from '@angular/common';
import {RouterLink} from '@angular/router';
import {AuthLayoutComponent} from '../auth-layout/auth-layout';
import {AuthService} from '../../services/auth.service';
import {SnackbarService} from '../../../../shared/services/snackbar.service';
import {ThemeService} from '@/app/core/services/theme/theme.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgClass,
    AuthLayoutComponent,
    RouterLink,
    CommonModule,
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class LoginComponent {
  private formBuilder = inject(FormBuilder);
  private authService = inject(AuthService);
  private snackbarService = inject(SnackbarService);
  private themeService = inject(ThemeService);
  protected submitted = false;
  protected showEmptyFieldsError = false;
  protected loginError = signal(false); // Para mostrar errores de login
  protected loginErrorMessage = signal<string | null>(null);
  protected themeContent = this.themeService.themeContent;
  protected loginContent = computed(() => this.themeContent()?.authComponent?.loginComponent);
  protected errorIcon = computed(() => this.themeService.getTheme()?.icons?.errorIcon);
  onSubmit() {
    this.showEmptyFieldsError = false;
    this.loginError.set(false);
    this.loginErrorMessage.set(null);
    this.submitted = true;
    if (this.formLogin.invalid) {
      // Verifica si hay campos vacíos
      const camposVacios = Object.keys(this.formLogin.controls).some((key) => {
        const control = this.formLogin.get(key);
        return control?.hasError('required') || control?.value === '';
      });
      if (camposVacios) {
        this.showEmptyFieldsError = true;
      }
      return;
    }
    this.authService
      .login({
        email: this.formLogin.value.email!,
        password: this.formLogin.value.password!,
      })
      .subscribe({
        next: (response) => {
          // this.router.navigate(['/inicio']);
        },
        error: (error) => {
          console.error('Error en el login:', error);
          this.loginError.set(true);
          this.submitted = false;
          // Personalizar mensaje según el tipo de error
          let errorMessage =
            'Credenciales incorrectas. Por favor, verifica tu email y contraseña.';
          if (error.status === 0) {
            errorMessage =
              'Error de conexión. Por favor, verifica tu conexión a internet.';
          } else if (error.status === 403) {
            this.loginErrorMessage.set(error.error);
            return;
          } else if (error.status === 500) {
            errorMessage =
              'Error del servidor. Por favor, inténtalo más tarde.';
          }
          this.snackbarService.showError(errorMessage);
        },
      });
  }
  formLogin = this.formBuilder.group({
    //email: new FormControl('', [Validators.required, Validators.email]),
   email: new FormControl(''),
    password: new FormControl('', [Validators.required, noSoloEspacios()]),
  });
  get email() {
    return this.formLogin.get('email');
  }
  get password() {
    return this.formLogin.get('password');
  }
}